import React, { useState } from "react";
import { PiEye, PiEyeClosedLight } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { login } from "../Reducer/authReducer";
import toast from "react-hot-toast";
import { Login } from "../Reducer/apiCall";
import Loader from "../Utils/Loader";

const SignIn = () => {
  const [isShow, setIsShow] = useState(false);
  const { status } = useSelector((state) => state.Chat);
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email address").required("Email is required"),
      password: Yup.string().min(6, "Password must be at least 6 characters").required("Password is required"),
    }),
    onSubmit: async(values) => {
      console.log(values);
      const res = await dispatch(Login(values))
            
      if (res?.status == 200) {
        dispatch(login(res?.data?.data));
        toast.success(res?.data?.message);
        localStorage.setItem("jwt-token", res?.data.token)
        navigate("/");
      } else {
        toast.error(res?.response?.data?.message || res?.message);

    }
    },
  });

  return (
    <div className="flex flex-col items-center my-6 text-white min-h-[80vh]">
   {status == "loading" && <Loader/>}
      <div className="p-3 w-[80%] sm:w-[60%] md:w-[50%] lg:w-[40%] min-w-72  border border-slate-400 bg-slate-800 rounded-lg h-fit mt-5 transition-all">
        <h2 className="text-2xl underline underline-offset-8 font-semibold text-white w-full text-center mb-4">
          Login
        </h2>
        <form className="w-full flex justify-between flex-col" onSubmit={formik.handleSubmit}>

          <h3 className="text-xl font-semibold p-1">Enter Email Address</h3>
          <input
            className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full flex justify-between bg-white text-black"
            type="email"
            placeholder="Enter Email Address"
            name="email"
            value={formik.values.email}
            onChange={formik.handleChange}
          />
          {formik.errors.email && formik.touched.email && (
            <span className="text-red-500 text-sm">{formik.errors.email}</span>
          )}

          <h3 className="text-xl font-semibold p-1">Enter Password</h3>
          <div className="relative">
            <input
              className="w-full border border-slate-700 my-3 py-4 px-8 rounded-full flex justify-between bg-white text-black"
              type={isShow ? "text" : "password"}
              placeholder="Enter Password"
              name="password"
              value={formik.values.password}
              onChange={formik.handleChange}
            />
            <span
              onClick={() => setIsShow(!isShow)}
              className="cursor-pointer text-black/80 absolute right-5 top-8"
            >
              {isShow ? (
                <PiEyeClosedLight fontSize={22} />
              ) : (
                <PiEye fontSize={22} />
              )}
            </span>
          </div>
          {formik.errors.password && formik.touched.password && (
            <span className="text-red-500 text-sm">{formik.errors.password}</span>
          )}

          <button
            type="submit"
            className="disabled:opacity-50 disabled:cursor-not-allowed w-1/2 mx-auto font-semibold hover:bg-slate-800 rounded-full px-5 py-4 mt-5 text-lg border border-slate-400 text-white bg-black transition-all"
          >
            Login
          </button>

          <div className="w-full flex items-center mt-3">
            <div className="w-full h-[1px] bg-slate-600"></div>
            <Link to="/forgotpassword">
              <div className="p-3 font-semibold text-md hover:text-white whitespace-nowrap">
                Forgot Password
              </div>
            </Link>
            <div className="w-full h-[1px] bg-slate-600"></div>
          </div>

          <div className="w-full flex items-center my-3">
            <div className="w-full h-[1px] bg-slate-600"></div>
            <Link to="/register">
              <div className="p-3 font-semibold text-md hover:text-white">
                Register
              </div>
            </Link>
            <div className="w-full h-[1px] bg-slate-600"></div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignIn;
